import { validation } from '@social-solutions/ssg-forms-processing';

export function getServerErrors(form, submissionErr) {
  if(!submissionErr || !submissionErr.validationResult || !submissionErr.validationResult.errors) {
    return [];
  }

  const validationErrors = submissionErr.validationResult.errors;

  return validationErrors.map(validationError => {
    if(!validationError) {
      return null;
    }

    if(!!validationError.responseElementId) {
      var element = validationError.responseElementId && form.elements.find(element => parseInt(element.id, 10) === validationError.responseElementId);
      return {
        errorMessage: validationError.message,
        sourceId: element && element.id,
        context: element && element.label,
        type: validation.errorTypes.global,
      }
    }
    else {
      return {
        errorMessage: validationError.message,
        sourceId: '0',
        context: '',
        type: validation.errorTypes.global,
      }
    }

  });
}

export const errorTypes = {
  inline: 'inline-error',
  global: 'global-error'
}

export function validationError(sourceId, label, section, errorNum, message, errorType = errorTypes.global) {
  const errorId = section + '-' + errorNum;
  return {
    id: "error-" + sourceId + "-" + errorId,
    sourceId,
    type: errorType,
    context: label,
    errorMessage: message
  };
};

export function sectionedValidationError(sourceId, label, subSection, section, errorNum, message, errorType = errorTypes.global) {
  var baseError = validationError(sourceId, label, section, errorNum, message, errorType);
  return {
    subSection,
    ...baseError
  };
}



// WEBPACK FOOTER //
// src/common/error-utilities.js